"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDebouncedValue = void 0;
var react_1 = require("react");
var useDebouncedValue = function (value, duration) {
    if (duration === void 0) { duration = 500; }
    var timerRef = react_1.useRef(null);
    var _a = react_1.useState(value), returnValue = _a[0], setReturnValue = _a[1];
    react_1.useEffect(function () {
        var _a;
        if (!window || !duration) {
            setReturnValue(value);
            return;
        }
        if (timerRef.current) {
            window.clearTimeout((_a = timerRef.current) !== null && _a !== void 0 ? _a : undefined);
        }
        timerRef.current = window.setTimeout(function () {
            setReturnValue(value);
            timerRef.current = null;
        }, duration);
    }, [JSON.stringify(value)]);
    if (!duration) {
        return value;
    }
    return returnValue;
};
exports.useDebouncedValue = useDebouncedValue;
